'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ThemeToggle({ className }: { className?: string }) {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();

  useEffect(() => setMounted(true), []);

  // next-themes only resolves the theme on the client after mount: on the
  // server (and the first client render) `resolvedTheme` is undefined, so a
  // theme-derived `title` would differ between SSR HTML and the hydrated
  // tree. Gate on `mounted` so both render the same deterministic output;
  // the post-mount re-render is a normal update, not a hydration mismatch.
  const isDark = mounted && resolvedTheme === 'dark';

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label="تبديل المظهر"
      title={isDark ? 'الوضع الفاتح' : 'الوضع الداكن'}
      className={cn('relative', className)}
    >
      <Sun className="scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
      <Moon className="absolute scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
    </Button>
  );
}
